import React from 'react';
import type { IWeeklyWorkflowKanbanProps, IKanbanTask } from '../types';

export const WeeklyWorkflowKanban = ({ data }: IWeeklyWorkflowKanbanProps) => {
    const days: IKanbanTask['day'][] = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta'];
    const categoryStyles: Record<IKanbanTask['category'], { bg: string; text: string; icon: string }> = {
        reuniao: { bg: 'bg-green-100 dark:bg-green-900/50', text: 'text-green-700 dark:text-green-300', icon: 'ph ph-users' },
        analise: { bg: 'bg-blue-100 dark:bg-blue-900/50', text: 'text-blue-700 dark:text-blue-300', icon: 'ph ph-chart-line-up' },
        relatorio: { bg: 'bg-yellow-100 dark:bg-yellow-900/50', text: 'text-yellow-700 dark:text-yellow-300', icon: 'ph ph-file-text' },
        criativo: { bg: 'bg-purple-100 dark:bg-purple-900/50', text: 'text-purple-700 dark:text-purple-300', icon: 'ph ph-lightbulb' },
        admin: { bg: 'bg-zinc-200 dark:bg-zinc-700/50', text: 'text-zinc-700 dark:text-zinc-300', icon: 'ph ph-briefcase' },
        social: { bg: 'bg-pink-100 dark:bg-pink-900/50', text: 'text-pink-700 dark:text-pink-300', icon: 'ph ph-share-network' },
        planejamento: { bg: 'bg-orange-100 dark:bg-orange-900/50', text: 'text-orange-700 dark:text-orange-300', icon: 'ph ph-calendar-check' }
    };

    const getCategoryDisplayName = (category: IKanbanTask['category']): string => {
        const names: Record<IKanbanTask['category'], string> = {
            reuniao: 'Reunião', analise: 'Análise', relatorio: 'Relatório',
            criativo: 'Criativo', admin: 'Admin', social: 'Social', planejamento: 'Planejamento'
        };
        return names[category] || category;
    };

    return (
        <div className="bg-surface p-4 rounded-lg card fade-in mt-4 border border-default" style={{ animationDelay: '0.9s' }}>
            <h3 className="text-base xl:text-lg font-bold text-zinc-900 dark:text-white mb-3">Meu Fluxo de Trabalho Semanal</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3 pb-3">
                {days.map(day => (
                    <div key={day} className="bg-subtle p-3 rounded-lg flex flex-col">
                        <h4 className="font-bold text-center text-zinc-900 dark:text-white mb-3 border-b border-zinc-200 dark:border-zinc-700 pb-2 text-sm">{day}</h4>
                        <div className="space-y-3">
                             {data.filter(task => task.day === day).map((task, index) => {
                                const cat = ((task as any).category || '').toString().toLowerCase();
                                const styles = (categoryStyles as any)[cat] || categoryStyles.reuniao;
                                 return (
                                     <div key={`${task.title}-${index}`} className="bg-white dark:bg-[#282828] p-3 rounded-md shadow-md">
                                         <p className="font-semibold text-zinc-800 dark:text-white text-sm">{task.title}</p>
                                         <div className="mt-1 flex items-center gap-3 text-xs text-zinc-600 dark:text-zinc-400">
                                             {task.location && (
                                                 <span className="inline-flex items-center gap-1"><i className="ph ph-map-pin"></i>{task.location}</span>
                                             )}
                                             <span className="inline-flex items-center gap-1"><i className="ph ph-clock"></i>{task.time}</span>
                                         </div>
                                        <div className={`mt-2 inline-flex items-center gap-2 px-2 py-1 text-xs font-bold rounded-full ${styles.bg} ${styles.text}`}>
                                            <i className={styles.icon}></i>
                                            <span>{getCategoryDisplayName((task as any).category)}</span>
                                         </div>
                                     </div>
                                 );
                             })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
